import axios from 'axios';

/* Axios instance created to avoid CORS error due to CSRF tOKEN */

export default axios.create({
  headers: { 'content-type': 'application/json' },
  responseType: 'json',
});
